import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { EquipmentFailureEffect } from './equipment-failure-effect';
import { FailureMechanism } from './failure-mechanism';
import { FailureModeUserAcceptance } from './failure-mode-user-acceptance';

export class EquipmentFailureMode implements ViewModel {
  friendlyTypeNameSingular: string = 'Failure Mode';
  apiRoute: string = CONFIG.apiRoutes.equipmentFailureMode;

  selected: boolean;
  id: string;
  code: string;
  name: string;
  failurePattern: FailurePattern = FailurePattern.Bathtub;
  shape: number;
  location: number;
  scale: number;
  nfactor: number;
  kfactor: number;
  failureRate: number;
  failureRateSource: string;
  characteristic: CharacteristicTypes = CharacteristicTypes.Evident;
  detection: number;
  maintenanceAnalysisUserAcceptanceId: string;
  isSaved: boolean = false;

  failureEffects: EquipmentFailureEffect[] = [];
  failureMechanisms: FailureMechanism[] = [];
  failureRateUomId: string;
  failureRateUom: FailureRateUom = FailureRateUom.None;
  userAcceptance: FailureModeUserAcceptance;

  rowIndex: number;
  plannedMaintenance: string;
  remarks: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.code = data.code;
    this.name = data.name;
    this.failurePattern = data.failurePattern;
    this.shape = data.shape;
    this.location = data.location;
    this.scale = data.scale;
    this.nfactor = data.nfactor;
    this.kfactor = data.kfactor;
    this.failureRate = data.failureRate;
    this.failureRateSource = data.failureRateSource;
    this.characteristic = data.characteristic;
    this.detection = data.detection;
    this.failureRateUom = data.failureRateUom;
    this.isSaved = data.isSaved;
    this.maintenanceAnalysisUserAcceptanceId =
      data.maintenanceAnalysisUserAcceptanceId;

    if (data.failureEffects) {
      this.failureEffects = data.failureEffects.map(
        (details: EquipmentFailureEffect) => {
          const newFailureEffect = new EquipmentFailureEffect();
          newFailureEffect.loadFromJson(details);
          return newFailureEffect;
        },
      );
    }

    if (data.failureMechanisms) {
      this.failureMechanisms = data.failureMechanisms.map(
        (details: FailureMechanism) => {
          const newMechanism = new FailureMechanism();
          newMechanism.loadFromJson(details);
          return newMechanism;
        },
      );
    }

    if (data.userAcceptance) {
      this.userAcceptance = new FailureModeUserAcceptance();
      this.userAcceptance.loadFromJson(data.userAcceptance);
    }
  }
}

export enum FailurePattern {
  Bathtub = 0,
  Fatigue = 1,
  InfantMortality = 2,
  InitialBreakinPeriod = 3,
  Random = 4,
  WearOut = 5,
}

export enum CharacteristicTypes {
  Hidden = 0,
  Evident = 1,
}

export enum FailureRateUom {
  None,
  Month,
  Year,
  OperatingHours,
}
